// export const api = "http://localhost:3001/";
export const api = "https://jyogram-api.onrender.com/";
// export const api = "https://socials-production.up.railway.app/";
